import { Navigate, Outlet } from 'react-router-dom';
import { useStateSelector } from '../../store/reducers';
import MainLayout from '../../components/layout/MainLayout';
import { useAuthSync } from '../../hooks/useAuthSync';
import LoadingScreen from '../../components/layout/LoadingScreen';

export function ProtectedLayout() {
  const { isReady } = useAuthSync();
  const usuario = useStateSelector((state) => state.authState.usuario);
  const isLoggedIn = Boolean(usuario?.email);

  // Espera a que Firebase resuelva onAuthStateChanged antes de decidir redirigir.
  // Sin esto, el store empieza vacío y redirige a login en cada F5.
  if (!isReady) return <LoadingScreen />;
  if (!isLoggedIn) return <Navigate to="/auth/login" replace />;

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
